import React from 'react';

/* eslint-disable max-len */
const Question = props => (
  <svg {...props} width="148" height="148" viewBox="0 0 82 82">
    <g fillRule="evenodd">
      <path d="M41 0C18.392 0 0 18.392 0 41s18.392 41 41 41 41-18.392 41-41S63.608 0 41 0zm0 76.875C21.219 76.875 5.125 60.781 5.125 41S21.219 5.125 41 5.125 76.875 21.219 76.875 41 60.781 76.875 41 76.875z" />
      <path d="M41.693 13.369c-10.122 0-18.355 8.233-18.355 18.352a2.563 2.563 0 0 0 5.125 0c0-7.293 5.936-13.227 13.23-13.227 7.292 0 13.225 5.934 13.225 13.227S48.985 44.95 41.693 44.95a2.563 2.563 0 0 0-2.562 2.562v9.906a2.563 2.563 0 0 0 5.125 0v-7.523c8.908-1.25 15.787-8.923 15.787-18.174 0-10.12-8.232-18.351-18.35-18.351z" />
      <ellipse cx="41.691" cy="67.143" rx="2.805" ry="2.805" />
    </g>
  </svg>
);

export default Question;
